// src/contexts/SearchContext.tsx

import React, { createContext, useState, ReactNode } from "react";

interface SearchContextType {
  isSearchMenuOpen: boolean;
  setIsSearchMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const SearchProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isSearchMenuOpen, setIsSearchMenuOpen] = useState<boolean>(false);

  return (
    <SearchContext.Provider
      value={{
        isSearchMenuOpen,
        setIsSearchMenuOpen,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = React.useContext(SearchContext);
  if (context === undefined) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
